import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Col, Row, Spinner } from "reactstrap";

const Profile = () => {
  const { t } = useTranslation();
  const { getProfileLoading, player } = useSelector((state) => state.Player);

  if (getProfileLoading) {
    return (
      <div style={{ textAlign: "center", padding: "20px" }}>
        <Spinner color="primary" />
        <div>Chargement en cours...</div>
      </div>
    );
  }

  return (
    <div style={{ padding: "20px" }}>
      <Row>
        {/* Première Colonne */}
        <Col md={5}>
          <div style={styles.infoProfile}>
            <span style={styles.titreInfo}>
              {t("playerInfo.profile.name")} :
            </span>
            {player?.lastName || "-"}
          </div>
          <div style={styles.infoProfile}>
            <span style={styles.titreInfo}>
              {t("playerInfo.profile.lastName")} :
            </span>{" "}
            {player?.firstName || "-"}
          </div>
          <div style={styles.infoProfile}>
            <span style={styles.titreInfo}>
              {t("playerInfo.profile.dateOfBirth")} :
            </span>{" "}
            {player?.dateOfBirth
              ? new Date(player.dateOfBirth).toLocaleDateString("fr-FR")
              : "-"}
          </div>
          <div style={styles.infoProfile}>
            <span style={styles.titreInfo}>
              {t("playerInfo.profile.email")} :
            </span>{" "}
            {player?.email || "-"}
          </div>
          <div style={styles.infoProfile}>
            <span style={styles.titreInfo}>
              {t("playerInfo.profile.phone")} :
            </span>
            {player?.phone || "-"}
          </div>
        </Col>

        {/* Deuxième Colonne */}
        <Col md={7}>
          <div style={styles.infoProfile}>
            <span style={styles.titreInfo}>
              {t("playerInfo.profile.username")} :
            </span>{" "}
            {player?.username || "-"}
          </div>
          <div style={styles.infoProfile}>
            {" "}
            <span style={styles.titreInfo}>
              {t("playerInfo.profile.club")} :
            </span>{" "}
            {player?.currentClub || "-"}
          </div>
          <div style={styles.infoProfile}>
            {" "}
            <span style={styles.titreInfo}>
              {t("playerInfo.profile.position")} :
            </span>{" "}
            {player?.position || "-"}
          </div>
          <div style={styles.infoProfile}>
            {" "}
            <span style={styles.titreInfo}>
              {t("playerInfo.profile.experienceLevel")} :
            </span>{" "}
            Expert
          </div>
          <div style={styles.infoProfile}>
            <span style={styles.titreInfo}>
              {t("playerInfo.profile.height")} :
            </span>{" "}
            {player?.height} cm
          </div>
          <div style={styles.infoProfile}>
            <span style={styles.titreInfo}>
              {t("playerInfo.profile.weight")} :
            </span>{" "}
            {player?.weight} kg
          </div>
        </Col>
      </Row>
    </div>
  );
};

const styles = {
  titreInfo: {
    color: "#000000",
  },
  infoProfile: {
    marginBottom: "18px",
    fontSize: "18px",
    font: "Poppins",
  },

  statInfo: {
    marginBottom: "18px",
    fontSize: "16px",
    font: "Poppins",
  },
  listeItem: {
    marginBottom: 2,
  },
};
export default Profile;
